import styled from "styled-components";
import { Link } from "react-scroll";

function SubMenu({ item }) {
  return (
    <Menu>
      <Link
        className="sublink"
        to={item}
        spy={true}
        smooth={true}
        offset={-100}
        duration={500}
        activeClass="nav-sublink-active"
      >
        {item}
      </Link>
    </Menu>
  );
}

export default SubMenu;

const Menu = styled.li`
  .sublink {
    font-weight: 500;
    letter-spacing: 0.2px;
    color: white;
    font-size: 0.9rem;
    padding: 0.2rem 0.5rem;

    color: #19456b;
    margin: 0;
    letter-spacing: 0.1px;
    margin-right: 1rem;

    :hover,
    :active {
      background: #e4e0e0;
      border-radius: 0.2rem;
    }

    @media (max-width: 1300px) {
      margin: 0rem 0.5rem;
    }
  }

  .nav-sublink-active {
    background: #e4e0e0;
    border-radius: 0.2rem;
  }
`;
